import { render, staticRenderFns } from "./StandartsCatalogStandart.vue?vue&type=template&id=1987b7fa&"
import script from "./StandartsCatalogStandart.vue?vue&type=script&lang=js&"
export * from "./StandartsCatalogStandart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports